import ApiConfig from "api/config";

const getTicketsAction = (pageNumber = 1, per_page = 10) => ({
    method: 'GET',
    endpoint: ApiConfig.urls.support.getTickets(pageNumber,per_page),
    params: {
        page: pageNumber,
        per_page: per_page,
    },
})

const createTicketAction = ({ payload }) =>({
    method: 'POST',
    endpoint: ApiConfig.urls.support.createTicket,
    body: payload,
})

const getTicketDetailsAction = (ticketId) => ({
    method: 'GET',
    endpoint: ApiConfig.urls.support.getTicketDetails(ticketId),
})

const sendMessageAction = ({ticketId, payload}) => ({
    method: 'POST',
    endpoint: ApiConfig.urls.support.sendMessage(ticketId),
    body: payload,
})

const markSeenAction = (ticketId) =>({
    method: 'POST',
    endpoint: ApiConfig.urls.support.markSeen(ticketId),
})

export { 
    getTicketsAction, 
    createTicketAction, 
    getTicketDetailsAction, 
    sendMessageAction, 
    markSeenAction
};